import { gql } from '@apollo/client';

export const getMatchingApplicants = () => gql`
  query getMatchingApplicants(
    $context: MatchingApplicantsContext!
    $entityId: Int!
    $page: Int
  ) {
    getMatchingApplicants(context: $context, entityId: $entityId, page: $page) {
      totalCount
      items {
        resume {
          id
          user {
            id
            name
            displayName
          }
          firstName
          lastName
          email
          title
          picture(style: "thumbnail") {
            alt
            url
          }
          desiredLocation
          careerStatus {
            label
          }
          availableStart
          privateFieldsAccess
          workXP {
            companyName
            timePeriod {
              startDate
              endDate
              untilNow
            }
          }
        }
        score
      }
      errors
    }
  }
`;
export default getMatchingApplicants;
